import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getFixedPreferenceDefaults } from "../fixedPreferenceForm";

const STEPS = [
  "Finition directe",
  "Cire d'occlusion",
  "Essayage d'armature",
  "Essayage esthétique",
];

export const StepPreferences = withForm({
  defaultValues: getFixedPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, ["step"]);

    return (
      <SaveableCard
        title="Étapes des prothèses fixes"
        description="Protocole proposé par défaut"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <Text variant="strong">Étapes</Text>
          <form.Field name="step">
            {field => (
              <Group>
                {STEPS.map(step => (
                  <ButtonCheckbox
                    key={step}
                    id={step}
                    isActive={field.state.value === step}
                    onClick={() => field.handleChange(step)}
                  >
                    {step}
                  </ButtonCheckbox>
                ))}
              </Group>
            )}
          </form.Field>
        </Stack>
      </SaveableCard>
    );
  },
});
